import {Component} from 'react'
// import {Navbar} from 'react-bootstrap'
import {
  Box,
  Flex,
  Spacer,
  HStack,
  Avatar,
  IconButton,
  Tooltip
} from '@chakra-ui/react';
import { ChatIcon, HamburgerIcon } from '@chakra-ui/icons';
import './Navigation.css'
import colors from '../../theme/colors';

class Navigation extends Component {
    render () {
      // Determine avatar name: "Gast" for guests, otherwise use username
      const isGuest = this.props.state.userVersion === 'guest';
      const avatarName = isGuest ? "Gast" : (this.props.state.username || "Username");
      const isFeedbackOpen = this.props.state.isFeedbackModalOpen;

      return (
        <>
          <Flex as="nav" p={{ base: "8px", md: "10px" }} bg = "gray.50" alignItems="center">

           {/* Mobile Menu Button - Only show on mobile when logged in */}
           {this.props.state.route !== 'login' && this.props.state.route !== 'register' && (
             <Box display={{ base: "block", md: "none" }}>
               <IconButton
                 icon={<HamburgerIcon />}
                 aria-label="Open menu"
                 variant="ghost"
                 size="md"
                 onClick={this.props.onOpenMobileMenu}
                 color="gray.600"
                 _hover={{ bg: colors.primary.pale, color: colors.primary.main }}
                 _active={{ bg: colors.primary.pale, color: colors.primary.main }}
               />
             </Box>
           )}

           <Spacer />
           <Box >
           <HStack spacing={{ base: "12px", md: "20px" }}>
              {this.props.state.route !== 'login' && this.props.state.route !== 'register' ?
              <>
                <Tooltip label="Feedback geven" placement="bottom">
                  <IconButton
                    icon={<ChatIcon />}
                    aria-label="Feedback geven"
                    variant="ghost"
                    size={{ base: "sm", md: "md" }}
                    onClick={this.props.onOpenFeedback}
                    color={isFeedbackOpen ? colors.primary.main : 'gray.600'}
                    bg={isFeedbackOpen ? colors.primary.pale : 'transparent'}
                    _hover={{
                      bg: isFeedbackOpen ? colors.primary.pale : colors.primary.pale,
                      color: colors.primary.main,
                      transform: 'scale(1.05)',
                      transition: 'all 0.2s'
                    }}
                  />
                </Tooltip>
                <Avatar
                  name={avatarName}
                  bg={colors.primary.main}
                  size={{ base: "sm", md: "md" }}
                />
              </>

              :
                null
              }
             </HStack>
              </Box>
            </Flex>
      </>
      )
    }
  }

export default Navigation